{
  "$schema": "./schema.json",
  "applicationPreview": {
    "heading": "Granska och skicka in",
    "pageTitle": "Din ansökan",
    "bidSelected": {
      "subheading": "Här ser du din ansökan"
    },
    "nonDraft": {
      "heading": "Din ansökan"
    },
    "submitCta": "Skicka in ansökan",
    "continueAndReceiveOffersCta": "Fortsätt och få erbjudanden",
    "showOffersCta": "Visa förslag",
    "backToOffersCta": "Tillbaka till erbjudanden",
    "backCta": "Tillbaka",
    "mostImportantInformationHeading": "Viktigaste informationen",
    "financialInformation": {
      "heading": "Finansiell information",
      "subtitle": "Lägg till rapporter och prognoser"
    },
    "collateralInformation": {
      "heading": "Information om säkerheter",
      "subtitle": "Lägg till information om säkerheter"
    },
    "repayment": {
      "heading": "Återbetalning av lånet",
      "subtitle": "Lägg till plan för återbetalning av lånet"
    },
    "additionalFinancingOffers": "Ytterligare erbjudanden",
    "additionalFinancingOffersExplainer": "För att även få erbjudanden om factoring, leasing eller fastighetslån, fyll i nödvändig information nedan.",
    "additionalFinancingOffersQuestionsAnswered": "{{outOf}} frågor besvarade",
    "factoringOffersHeading": {
      "title": "Sälj era fakturor",
      "subtitle": "Få betalt redan idag (upp till 100 % av fakturabeloppet)"
    },
    "leasingOffersHeading": {
      "title": "Leasa utrustning eller maskiner",
      "subtitle": "Du får vanligtvis en lägre månadskostnad"
    },
    "realEstateOffersHeading": {
      "title": "Finansiera med fastighet som säkerhet",
      "subtitle": "Lämna säkerhet i privat eller kommersiell fastighet för att få lägre ränta"
    },
    "steps": {
      "nextStep": "Nästa steg",
      "common": {
        "reviewAndSubmit": "Granska och skicka in",
        "creditCheck": "Vi förbereder din ansökan – endast en kreditupplysning tas på företaget och borgensmännen",
        "improveApplication": "Vi analyserar ansökan för att säkerställa att du får de bästa möjliga villkoren",
        "receiveFunds": "Välj det bästa erbjudandet och få finansieringen utbetald"
      }
    },
    "popup": {
      "title": {
        "loading": "Tack, nästan klart...",
        "applicationSent": "Ansökan inskickad",
        "applicationDigitalAdvice": "Nedan kan du se förbättringar vi identifierat för din ansökan.",
        "applicationAdvice": "Ditt företag kvalificerar sig för kostnadsfri rådgivning.",
        "applicationNotSent": "Ansökan inte inskickad än"
      },
      "preloader": "Vi analyserar din ansökan och förbereder dina kredithandlingar"
    },
    "strengthenApplicationHeading": "Stärk din ansökan",
    "recommended": "Rekommenderad",
    "optional": "Valfri",
    "required": "Obligatorisk",
    "whatHappensNext": {
      "title": "Vad händer härnäst?",
      "description": "Endast en kreditupplysning tas på ditt företag och angivna borgensmän och din ansökan skickas sedan vidare till långivare. Ju mer information du lämnar, desto större är chansen att du får bättre erbjudanden."
    },
    "companyInformation": "Företagsinformation",
    "companyName": "Företagsnamn",
    "organisationNumber": "Organisationsnummer",
    "contactDetails": "Kontaktuppgifter",
    "contactPerson": "Kontaktperson",
    "phoneNumber": "Telefonnummer",
    "applicationStatus": "Ansökningsstatus",
    "done": "Klar",
    "fieldsLeft": "{{count}} kvar",
    "submit": {
      "title1": "Förbereder din ansökan...",
      "title2": "Analyserar din ansökan...",
      "titleDone": "Vi har analyserat din ansökan",
      "continueWithoutImprovements": "Fortsätt utan förbättringar",
      "digitalAdvice": {
        "description": "Vi identifierade {{count}} förbättringar – de tar bara 2–3 minuter",
        "descriptionOne": "Vi identifierade 1 förbättring - den tar bara 2-3 minuter ",
        "cta": "Se förbättringar"
      },
      "revenueAdvice": {
        "description": "Du kan få bättre erbjudanden genom att bifoga aktuell omsättning - det tar bara 2-3 minuter att lägga till",
        "cta": "Lägg till aktuell omsättning"
      },
      "manualAdvice": {
        "description": "Du kan få bättre villkor genom vår rådgivningstjänst",
        "cta": "Fortsätt till rådgivningstjänsten"
      }
    },
    "support": {
      "ctaText": "Frågor?",
      "previewContactPersonMessage": "<b>Behöver du hjälp med din ansökan?</b><br/>  Ring {{firstName}}, din tilldelade rådgivare: <a>{{mobilePhoneNumber}}</a>"
    },
    "showMore": "Visa mer",
    "showLess": "Visa mindre"
  }
}
